import { useCallback, useEffect, useRef, useState } from 'react';
import { SSEChat } from '../app/services/SSEChat';

export function useSSEChat(functionUrl: string) {
	const [text, setText] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const stopRef = useRef<null | (() => void)>(null);

	useEffect(() => {
		SSEChat.configure(functionUrl);
		try { if (functionUrl) console.log('[useSSEChat] configured URL', functionUrl); } catch {}
	}, [functionUrl]);

	const start = useCallback((message: string, context: any = {}, opts?: { onProgram?: (status: string, id?: string | null) => void; onMeal?: (status: string) => void }) => {
		if (stopRef.current) { stopRef.current(); stopRef.current = null; }
		setText('');
		setError(null);
		setLoading(true);
		try { console.log('[useSSEChat] start called', { hasContext: !!context && Object.keys(context||{}).length>0 }); } catch {}
		stopRef.current = SSEChat.start(message, context, {
			onStart: () => {},
			onDelta: (delta) => setText(prev => prev + delta),
			onEnd: () => setLoading(false),
			onError: (msg) => { setError(msg); setLoading(false); },
			onProgram: (status, id) => { opts?.onProgram && opts.onProgram(status, id || undefined); },
			onMeal: (status) => { opts?.onMeal && opts.onMeal(status); }
		});
	}, []);

	const stop = useCallback(() => {
		if (stopRef.current) { stopRef.current(); stopRef.current = null; }
		setLoading(false);
	}, []);

	return { text, loading, error, start, stop };
}


